module.exports = __webpack_public_path__ + "static/media/keyring_dolphin.b0369918.webp";